import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-tracks-empty';
export var ID = 'icon-tracks-empty';
/* eslint-disable max-len */

export var SVGTracksEmpty = function SVGTracksEmpty() {
  return React.createElement("symbol", {
    id: ID,
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-808.000000, -860.000000)",
    stroke: "#A8A0A0",
    strokeWidth: "1.5"
  }, React.createElement("g", {
    transform: "translate(808.000000, 860.000000)"
  }, React.createElement("path", {
    d: "M11,5 L11,56 L48.5,56 L48.5,14 L39.5,5 L11,5 Z M39.5,5 L39.5,14 L48.5,14 M20,43.999625 L39.5,43.999625 L20,43.999625 Z M20,37.999625 L39.5,37.999625 L20,37.999625 Z M29,31.999625 L39.5,31.999625 L29,31.999625 Z M20.75,19.999625 L20.75,31.249625 L28.25,25.624625 L20.75,19.999625 Z"
  })))));
};
/* eslint-disable max-len */

var TracksEmpty = function TracksEmpty(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGTracksEmpty
  });
};

TracksEmpty.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default TracksEmpty;